<template>
    <div
        class="tw-bg-white tw-border tw-border-gray-200 tw-rounded-xl tw-shadow-smx tw-relative tw-p-5 tw-flex tw-flex-col tw-items-center tw-justify-between tw-min-h-[260px] tw-h-full hover:tw-shadow-md hover:tw-border-primary-300 tw-transition-all tw-duration-200 tw-cursor-pointer">
        <!-- Bookmark Icon -->
        <button
            class="tw-absolute tw-top-3 tw-right-3 tw-z-10 tw-p-1.5 tw-rounded-full hover:tw-bg-gray-100 tw-transition-colors tw-duration-150"
            @click.stop="onBookmark" :disabled="bookmarkLoading" aria-label="Bookmark">
            <icon v-if="!bookmarkLoading" :icon="bookmarked ? 'solar:bookmark-bold' : 'solar:bookmark-outline'"
                class="tw-text-2xl tw-text-primary-500" />
            <svg v-else class="tw-animate-spin tw-h-6 tw-w-6 tw-text-primary-400" fill="none" viewBox="0 0 24 24">
                <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
            </svg>
        </button>

        <!-- Clickable Card Content -->
        <router-link :to="{ name: 'shared.company-profile', params: { id: company.id } }"
            class="tw-w-full tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-between tw-text-decoration-none">
            <!-- Top Info -->
            <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-mb-4">
                <div class="tw-text-md tw-font-bold tw-text-gray-900 tw-leading-tight tw-mb-1 tw-truncate"
                    :title="company.name">
                    {{ company.name }}
                </div>
                <div v-if="company.pavilion" class="tw-text-gray-500 tw-text-base tw-truncate">
                    {{ company.pavilion }}
                </div>
            </div>

            <!-- Company Logo/Image -->
            <div class="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-w-full tw-mb-2">
                <div v-if="company.logo" class="tw-w-full tw-flex tw-justify-center">
                    <img :src="company.logo" :alt="company.name"
                        class="tw-max-h-28 tw-object-contain tw-rounded-md tw-bg-gray-50 tw-w-auto tw-h-auto" />
                </div>
                <div v-else
                    class="tw-w-32 tw-h-28 tw-bg-gray-100 tw-rounded-md tw-flex tw-items-center tw-justify-center">
                    <icon icon="solar:buildings-2-bold-duotone" class="tw-text-4xl tw-text-primary-300" />
                </div>
            </div>
        </router-link>
    </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import bookmarksApi from '@/api/bookmarks';

const props = defineProps({
    company: {
        type: Object,
        required: true
    }
});

const bookmarked = ref(props.company.is_bookmarked);
const bookmarkLoading = ref(false);

const onBookmark = async () => {
    bookmarkLoading.value = true;

    await bookmarksApi.toggle({
        bookmarkable_type: 'company',
        bookmarkable_id: props.company.id
    })

    bookmarked.value = !bookmarked.value;
    bookmarkLoading.value = false;
}
</script>

<style scoped>
/* Add any custom styles here */
</style>